/**
 * ResetPasswordModal
 */

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { useApi2fetch } from 'containers/Api2/index.js';
import { EMPLOYEE_ROLE, STUDENT_ROLE } from 'containers/User/constants.js';
import Password from 'components/interaction/Password/index.jsx';
import PrimaryAction from 'components/interaction/PrimaryAction/index.jsx';
import AlertList from 'components/AlertList/index.jsx';
import messages from '../messages.js';

function ResetPasswordModal(props) {
  const { user, onHide } = props;
  const [password, setPassword] = useState();
  const api2fetch = useApi2fetch();
  const { id, firstName, lastName, email, username, roleType } = user || {};
  const userData = useMemo(() => ({ firstName, lastName, email: email?.email, username }), [user]); // eslint-disable-line react-hooks/exhaustive-deps
  if (![EMPLOYEE_ROLE, STUDENT_ROLE].includes(roleType)) {
    return null;
  }
  async function handleSubmit(ev) {
    ev.preventDefault();
    const options = {
      method: 'POST',
      url: `sa/users/resetpassword?roleType=${roleType}&userId=${id}`,
      version: 2,
      body: { password },
      success: messages.passwordChanged,
    };
    await api2fetch(options);
    onHide();
  }

  return (
    <Modal show={Boolean(user)} size="sm" onHide={onHide}>
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage {...messages.resetPassword} />
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <AlertList />
          <Password onChange={(o) => setPassword(o.password)} userData={userData} isAdmin />
        </Modal.Body>
        <Modal.Footer>
          <PrimaryAction onCancel={onHide} />
        </Modal.Footer>
      </form>
    </Modal>
  );
}

ResetPasswordModal.propTypes = {
  user: PropTypes.object,
  onHide: PropTypes.func,
};

export default ResetPasswordModal;
